import { render, staticRenderFns } from "./FlashBuy.vue?vue&type=template&id=4cc23c9d&scoped=true&"
import script from "./FlashBuy.vue?vue&type=script&lang=js&"
export * from "./FlashBuy.vue?vue&type=script&lang=js&"
import style0 from "./FlashBuy.vue?vue&type=style&index=0&id=4cc23c9d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc23c9d",
  null
  
)

export default component.exports